<style lang="scss">
    .yuan{
        width:12px;height: 12px;border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
    }

</style>

<template>
    <div class="search-wrap searchb2c">
        <article class="search-main clearfix">
            <div class="pull-right">
                <Form inline>
                    <Button type="primary" @click="update(true)" icon="ios-search">查询</Button>
                    <Button @click="resetdata" icon='md-refresh'>重置</Button>
                    <Button type="dashed" @click="isOpen=!isOpen">更多查询<Icon type="ios-arrow-down" class="margin-left-5"></Icon></Button>
                </Form>
            </div>
            <div class="pull-right">
                <Form :label-width="80" inline>
                    <FormItem label='项目'>
                        <Select v-model="formData.IN_lineId" filterable multiple>
                            <Option v-for="item in products" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                     <FormItem label='ERPSKU'>
                        <Input clearable v-model.trim="formData['EQ_erpSku']" />
                    </FormItem>
                     <FormItem label='品类'>
                        <Input clearable v-model.trim="formData['EQ_pinlei']" />
                    </FormItem>
                </Form>
            </div>

        </article>
        <transition name='slide-both' >
            <div v-show="isOpen">
                <Form class="search-other" :label-width="110" inline >

                    <FormItem label='补货状态' style="width:330px;">
                        <Select clearable v-model="formData.EQ_isBusinessOrder" >
                            <Option v-for="item in replenList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label='是否停用' style="width:330px;">
                        <Select v-model="formData.IN_errorCode" filterable multiple>
                            <Option v-for="item in isUsed" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label='品名' style="width:330px;">
                        <Input v-model="formData.EQ_orderNo" placeholder="同时支持订单序号/订单号查询"></Input>
                    </FormItem>

                    <FormItem label='是否季节性' style="width:330px;">
                        <Select v-model="formData.IN_orderType" filterable multiple>
                            <Option v-for="item in isSeasonal" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>

                    <FormItem label='产品类型' style="width:330px;">
                        <Select v-model="formData.IN_orgWarehouseId" filterable multiple>
                            <Option v-for="item in peoductsType" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>

                    <FormItem label='更新时间' style="width:330px;">
                        <DatePicker type="date" style="width:220px" v-model="formData.GE_orderDate"></DatePicker>
                    </FormItem>
                </Form>
            </div>
        </transition>
        <transition>
            <Form inline class="search-other" v-if="changekeys!='LE_latestShipDate'">
                <Button class="margin-right-5 dark-primary" @click="handleModal('resetorder')">添加</Button>


                <Dropdown @on-click="handleModal">
                    <Button class="margin-right-5" type="success">
                        导入
                        <Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem name="importBase">导入基本信息</DropdownItem>
                        <DropdownItem name="importWarehouse">导入仓库发货信息</DropdownItem>
                        <DropdownItem name="importHead">导入头程信息</DropdownItem>
                        <DropdownItem name="importBuy">导入采购信息</DropdownItem>
                    </DropdownMenu>
                </Dropdown>

                <Button type="info" class="margin-right-5" @click="handleModal('activeorder')">查询条件导出</Button>

                <Dropdown @on-click="handleModal" >
                    <Button class="margin-right-5 middle-content">
                        批量增加标签
                        <Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem v-for="item in iconList" :key="item.index" :name="item.value"><span class="yuan" :class="item.color"></span>{{item.label}}</DropdownItem>
                    </DropdownMenu>
                </Dropdown>

                <Dropdown @on-click="handleModal" style="width:120px">
                    <Button type="error">
                        批量激活/停用
                        <Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem name="actived">激活</DropdownItem>
                        <DropdownItem name="disabled">停用</DropdownItem>
                    </DropdownMenu>
                </Dropdown>

            </Form>
        </transition>
    </div>
</template>

<script>
    import { HttpGroupRuleItem } from '@/service/boss/allot'
    import { HttpGetStates } from '@/service/boss/b2corder'
    import { mapState } from 'vuex'

    export default {
        data() {
            return {
                SYSID:'',
                aaaa:"",
                isOpen: false,
                getdate:[],
                routerName:this.$route.name,
                states:[],
                formData:{
                    IN_lineId:"",
                },
                allisAddition:'',
                changekeys:'',
                // 补货状态
                replenList: [
                    { value: 'Y',label: '正常补货' },
                    { value: 'N',label: '不再补货' },
                ],
                // 是否停用
                isUsed: [
                    { value: 'Y',label: '是' },
                    { value: 'N',label: '否' },
                ],
                // 是否季节性
                isSeasonal:[
                    { value: 'Y',label: '季节性商品' },
                    { value: 'N',label: '非季节性商品' },
                ],
                // 产品类型
                peoductsType:[
                    { value: 'AFN',label: '成品' },
                    { value: 'MFN',label: '配件' },
                    { value: 'M11FN',label: '耗材' },
                ],

                // 后端需要给的标签形式
                iconList:[
                    {value:'1',label:'走量款',color:'ICblue'},
                    {value:'2',label:'形象款',color:'ICred'},
                ]
            };
        },
        created() {

            this.update();
        },
        computed: {
            ...mapState('boss',['products']),
    },
    methods: {
        handleModal(type,id) {
            this.$parent.handleOperate(id,type)
        },
        getlocalStage(){

        },
        update(type,parms){
            console.log(1111)
        },
        resetdata(){

        },
        exportXlsx(){
            console.log(2222)
        },


    },
    };
</script>
